import { Box, IconButton, Toolbar, Button, Typography, useTheme, useMediaQuery } from '@mui/material';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import { StyledAppBar } from './styles';
import { WhiteLogoIcon } from '@/components/Icons/Icons';
import logoEmblem from '@/assets/NoteGoLogo_Emblem_Reverse.png';
import { GoldButton } from '@/components/GoldButton';

export const PublicNavbar = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));

  const handleLogoClick = () => {
    window.open('https://notego.ai/', '_blank', 'noopener,noreferrer');
  };

  const handleLearnMoreClick = () => {
    window.open('https://notego.ai/', '_blank', 'noopener,noreferrer');
  };

  const handleSignupClick = () => {
    window.open('/login?action=signup', '_blank', 'noopener,noreferrer');
  };

  const handleLoginClick = () => {
    // Bring the viewer back to this note after login (PublicNote then forwards
    // signed-in viewers to /shared/:token) — otherwise login lands on Home.
    // Scoped to note pages: this navbar also renders on the 404 page.
    if (window.location.pathname.startsWith('/public/')) {
      sessionStorage.setItem('redirectAfterLogin', window.location.pathname);
    }
    window.location.href = '/login';
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <StyledAppBar sx={{ border: 'none' }}>
        <Toolbar sx={{ minHeight: isMobile ? 56 : 64, px: isMobile ? 1 : 3 }}>
          {/* Logo */}
          <IconButton onClick={handleLogoClick} sx={{ p: isMobile ? 0.5 : 1 }}>
            {isMobile ? (
              <img src={logoEmblem} alt="NoteGo" style={{ width: '32px', height: '32px' }} />
            ) : (
              <WhiteLogoIcon sx={{ width: '204.8px', height: '32px' }} />
            )}
          </IconButton>

          {/* Tagline - centered, responsive */}
          <Box
            sx={{
              flexGrow: 1,
              display: 'flex',
              justifyContent: 'center',
              px: 2,
            }}
          >
            {!isMobile && (
              <Typography
                sx={{
                  color: 'rgba(255, 255, 255, 0.9)',
                  fontSize: isTablet ? '12px' : '14px',
                  fontWeight: 400,
                  textAlign: 'center',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                {isTablet
                  ? 'Create AI-powered notes with NoteGo'
                  : 'Like what you see? Create your own AI-powered notes with NoteGo.'}
              </Typography>
            )}
          </Box>

          {/* CTA Buttons */}
          <Box sx={{ display: 'flex', gap: isMobile ? 1 : 1.5, alignItems: 'center' }}>
            <Button
              variant="outlined"
              onClick={handleLearnMoreClick}
              sx={{
                textTransform: 'none',
                color: 'rgba(255, 255, 255, 0.9)',
                borderColor: 'rgba(255, 255, 255, 0.5)',
                fontWeight: 500,
                fontSize: isMobile ? '12px' : '14px',
                px: isMobile ? 1.5 : 2,
                py: isMobile ? 0.5 : 0.75,
                borderRadius: '100px',
                minWidth: 'auto',
                '&:hover': {
                  bgcolor: 'rgba(255, 255, 255, 0.1)',
                  borderColor: 'rgba(255, 255, 255, 0.8)',
                },
              }}
            >
              Learn More
            </Button>
            <GoldButton
              onClick={handleSignupClick}
              shimmerOpacity={0.3}
              sx={{
                fontSize: isMobile ? '12px' : '14px',
                px: isMobile ? 1.5 : 2.5,
                py: isMobile ? 0.5 : 0.75,
                whiteSpace: 'nowrap',
              }}
            >
              {isMobile ? 'Free Trial' : 'Start Free Trial'}
            </GoldButton>
            <Button
              onClick={handleLoginClick}
              startIcon={<AccountCircleOutlinedIcon />}
              sx={{
                textTransform: 'none',
                color: 'rgba(255, 255, 255, 0.9)',
                fontWeight: 500,
                fontSize: isMobile ? '12px' : '14px',
                px: isMobile ? 1 : 1.5,
                py: isMobile ? 0.5 : 0.75,
                minWidth: 'auto',
                '&:hover': {
                  bgcolor: 'rgba(255, 255, 255, 0.1)',
                },
              }}
            >
              Log In
            </Button>
          </Box>
        </Toolbar>
      </StyledAppBar>
    </Box>
  );
};
